import { styled, css } from 'styled-components';

// ── Account selector wrapper ──

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  min-width: 0;
`;

export const ChipsArea = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  min-width: 0;
`;

export const ProfileChip = styled.div<{ $isUnknown?: boolean }>`
  ${({ theme: { colors, fontSizes, fontWeights }, $isUnknown }) => css`
    align-items: center;
    background: ${colors.brandDarkTint95};
    border-radius: 0.25rem;
    cursor: default;
    display: flex;
    gap: 0.375rem;
    padding: 0.25rem 0.25rem 0.25rem 0.375rem;
    user-select: none;

    ${
      $isUnknown &&
      css`
        padding-left: 1rem;
      `
    }

    p {
      font-size: ${fontSizes.s12};
      font-weight: ${fontWeights.medium};
      margin: 0;
      max-width: 9rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .button {
      background: transparent;
      border-radius: 0.25rem;
      height: 1.5rem;
      min-width: unset;
      width: 1.5rem;

      .icon {
        font-size: 0.875em;
      }
    }
  `}
`;

export const ProfileAvatarWrapper = styled.div<{ $isUnknown?: boolean }>`
  ${({ theme: { colors } }) => css`
    flex-shrink: 0;
    position: relative;
    width: 1.5rem;
    height: 1.5rem;

    .avatar-img,
    .avatar-initials {
      align-items: center;
      background: ${colors.brandPrimary};
      border-radius: 0.25rem;
      display: flex;
      height: 1.5rem;
      justify-content: center;
      overflow: hidden;
      width: 1.5rem;

      img {
        border-radius: 0.25rem;
        height: 1.5rem;
        object-fit: cover;
        object-position: center;
        width: 1.5rem;
      }

      p {
        color: ${colors.brandLight};
        font-size: 0.75rem;
        font-weight: 600;
        line-height: 1;
        margin: 0;
      }
    }

    .network-badge {
      align-items: center;
      background: ${colors.brandLight};
      border-radius: 50%;
      bottom: -0.1875rem;
      box-shadow: 0 0 0 1.5px ${colors.brandLight};
      display: flex;
      height: 0.875rem;
      justify-content: center;
      position: absolute;
      right: -0.1875rem;
      width: 0.875rem;
      z-index: 1;

      .icon {
        display: block;
        height: 0.75rem;
        width: 0.75rem;
      }
    }
  `}
`;

export const OverflowChip = styled.div`
  ${({ theme: { colors, fontSizes, fontWeights } }) => css`
    align-items: center;
    background: ${colors.brandDarkTint95};
    border-radius: 0.25rem;
    display: flex;
    overflow: hidden;
    user-select: none;

    button {
      align-items: center;
      background: none;
      border: none;
      color: ${colors.brandDark};
      cursor: pointer;
      display: flex;
      font-family: inherit;
      font-size: ${fontSizes.s12};
      font-weight: ${fontWeights.semiBold};
      justify-content: center;
      margin: 0;
      padding: 0.25rem 0.5rem;

      &:hover {
        background: ${colors.brandDarkTint90};
      }
    }
  `}
`;

export const OverflowPanel = styled.div`
  ${({ theme: { colors, spacings } }) => css`
    background: ${colors.brandLight};
    border-radius: 0.25rem;
    box-shadow:
      0 0 0 1px ${colors.brandDarkTint80},
      0 0.75rem 0.5rem -0.25rem rgba(32, 30, 36, 0.15),
      0 0.25rem 0.25rem -0.125rem rgba(32, 30, 36, 0.2);
    display: flex;
    flex-direction: column;
    gap: ${spacings.s4};
    max-height: 20rem;
    overflow-y: auto;
    padding: ${spacings.s8};
    width: 16rem;
    z-index: 100;
  `}
`;
